"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = toArray;
function toArray(object) {
  var result = [];
  Object.keys(object).forEach(function (key) {
    if (object.hasOwnProperty(key)) {
      result.push(object[key]);
    }
  });
  return result;
}


//////////////////
// WEBPACK FOOTER
// ./~/react-redux-form/lib/utils/to-array.js
// module id = 1324
// module chunks = 0